import React from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import noop from 'lib/function/noop'
import SearchAccommodation from 'tripPlanner/components/TripModal/TripItems/Search/SearchAccommodation'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

type Props = {
  tripId: string
  sectionId?: string
  onClick?: () => void
}

function HotelSearchModalCTA({ tripId, sectionId, onClick = noop }: Props) {
  const intl = useIntl()
  const openModal = useOpenModal()
  return (
    <TextButton
      kind="primary"
      startIcon={<LineSearchIcon />}
      onClick={() => {
        onClick()
        openModal(SearchAccommodation, {
          tripId,
          sectionId,
        })
      }}
    >
      {intl.formatMessage({
        id: 'zbSF7s37bO',
        defaultMessage: 'Search hotels',
        description: 'Action button to open hotel search modal in trip planner',
      })}
    </TextButton>
  )
}

export default HotelSearchModalCTA
